import React from 'react';
import './heroInfo.scss';
import IMAGE_3 from 'assets/accounting-finance/finance_image_3.png';

import {HeadingElement, Button} from "components";
import {useNavigate} from "react-router-dom";

export const HeroInfo = () => {
    const navigate = useNavigate()

    return (
        <div className={'hero-info '}>
            <div className="hero-info_wrapper max ">
                <div className="hero-info_wrapper_left">
                    <HeadingElement/>
                    <h1>Simplify your business accounting and financial process</h1>
                    <p>Accounting and finance is a very important process in business administration, which require
                        a lot of attention, and time to get it done properly. Get the help you need to meet all your
                        business financial and accounting goals.</p>
                    <Button text={"Join Us"} type={'primary'} onclick={() => navigate('/registration')}/>
                </div>

                <div className="hero-info_wrapper_right">
                    <div className="hero-info_wrapper_right_image">
                        <img id='finance_3' src={IMAGE_3} alt=""/>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default HeroInfo;
